export default {
    type: 'النوع',
    'bond-no': 'رقم السند',
    'start-date': 'من التاريخ',
    'end-date': 'إلى التاريخ',
    'bond-status': 'حالة السند',
    'refresh': 'تحديث',
    all: 'الكل',
    'posted': 'مُرحّلة',
    'non-posted': 'غير مُرحّلة',
    'cash': 'نقدية',
    'accounting': 'محاسبية',
    'total-count': 'العدد الكلي:',
    'non-posted-bonds-count': 'عدد السندات الغير مُرحلّة:',
    'delete-bond': 'حذف سطر',
    'do-you-want-to-delete-$-bond-with-no-$': 'هل تريد حذف اليومية ال{type} ذات الرقم {no}',

    'right-click-menu-items': {
        'go-to-the-journal': 'الانتقال إلى اليومية',
        delete: 'حذف',
    },

    headers: {
        'serial': 'تسلسل',
        'bond-no': 'رقم السند',
        'type': 'النوع',
        'status': 'الحالة',
        'date': 'التاريخ',
    }
}